import { render } from "./Import_Permissions.vue?vue&type=template&id=24243e50"
import script from "./Import_Permissions.vue?vue&type=script&lang=js"
export * from "./Import_Permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__